import BaseRequest from '@/qingyu/request/base'
import { config } from '@/qingyu'

/**
 * 用户相关API请求类
 */
export default class UserRequest extends BaseRequest {
  // 微信登录
  wechatLogin(code) {
    return this.post('/auth/wechat/login', { code })
  }
  
  // 账号密码登录
  login(data) {
    return this.post(config.api.SITE.LOGIN, data)
  }
  
  // 用户注册
  register(data) {
    return this.post(config.api.SITE.REGISTER, data)
  }
  
  // 获取验证码
  getVerifyCode(phone) {
    return this.post('/auth/verifyCode', { phone })
  }

  // 获取用户信息
  getUserInfo() {
    return this.get(config.api.USER.GET_USER_INFO)
  }

  // 员工扫码绑定
  bindEmployee(code) {
    return this.post('/auth/employee/bind', { code })
  }
  
  // 更新用户资料
  updateUserInfo(data) {
    return this.put('/auth/user/info', data)
  }
  
  // 修改密码
  changePassword(data) {
    return this.put('/auth/user/password', data)
  }
  
  // 绑定手机号
  bindPhone(data) {
    return this.post('/auth/user/phone/bind', data)
  }
  
  // 获取企业信息
  getCompanyInfo() {
    return this.post(config.api.ENTERPRISE.COMPANY_INFO)
  }
  
  // 编辑企业信息
  editCompanyInfo(data) {
    return this.post(config.api.ENTERPRISE.EDIT_COMPANY_INFO, data)
  }
  
  // 获取企业账号列表
  getCompanyAccountList(company_id) {
    return this.post(config.api.ENTERPRISE.COMPANY_ACCOUNT_LIST, { company_id })
  }
  
  // 添加企业账号
  addCompanyAccount(data) {
    return this.post(config.api.ENTERPRISE.COMPANY_ACCOUNT_ADD, data)
  }
  
  // 解绑他人企业账号
  deleteCompanyAccount(id) {
    return this.post(config.api.ENTERPRISE.COMPANY_ACCOUNT_DELETE, { id })
  }
  
  // 解绑自己的企业账号
  deleteSelfCompanyAccount(company_id) {
    return this.post(config.api.ENTERPRISE.COMPANY_ACCOUNT_SELF_DELETE, { company_id })
  }

  // 登出
  logout() {
    return this.post('/auth/logout')
  }
} 